import React, { useCallback, useEffect, useState } from 'react'

import WebSettingsCard from 'live/components/ui/admin/web-settings-card'
import globalNotification from 'live/services/global-notification'
import { StyledTableForm } from 'live/settings/styled'
import { useWebSettingsState } from 'live/settings/useWebSettingsState'
import { confirmReset } from 'live/settings/utils'

const OptionsCard = ({ optionName, optionEndpointPath, fields }) => {
    const [options, setOptions] = useState([])

    const { state, actions } = useWebSettingsState(options)

    const fetchOptions = useCallback(() => {
        fetch(`/services/plugin-channel-alarms/settings/acknowledge/${optionEndpointPath}`)
            .then(r => {
                if (r.ok) {
                    return r.json()
                }

                return Promise.reject(new Error(r.statusText))
            })
            .then(r => {
                setOptions(r)
                actions.setPersistedData(r)
            })
    }, [actions, optionEndpointPath])

    const resetOptions = useCallback(
        () =>
            confirmReset(() => {
                fetch(`/services/plugin-channel-alarms/settings/acknowledge/${optionEndpointPath}/reset`, {
                    method: 'POST'
                }).then(r => {
                    if (r.ok) {
                        fetchOptions()
                    } else {
                        return Promise.reject(new Error(r.statusText))
                    }
                })
            }),
        [fetchOptions, optionEndpointPath]
    )

    const onSave = useCallback(() => {
        actions.submit()

        fetch(`/services/plugin-channel-alarms/settings/acknowledge/${optionEndpointPath}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(options)
        })
            .then(r => {
                if (r.ok) {
                    actions.saveSuccess(options)
                    globalNotification.success('Settings successfully saved')
                } else {
                    return Promise.reject(r)
                }
            })
            .catch(async r => actions.setError((await r.json()).message))
    }, [actions, optionEndpointPath, options])

    useEffect(() => {
        fetchOptions()
    }, [fetchOptions])

    return (
        <WebSettingsCard
            name="reason-options"
            className="live-feature mb-15"
            open={state.open}
            error={state.submitted ? state.error : null}
            saved={state.open && state.saved}
            save={onSave}
            toggle={actions.toggle}
            onCancel={() => setOptions(state.persistedData)}
        >
            <div className="live-feature__header">
                <h2 className="flex-1">Acknowledgement {optionName} options</h2>
                <a onClick={resetOptions}>{'Restore defaults'}</a>
            </div>

            <StyledTableForm
                data={options}
                fields={(fields || []).map(field => ({ ...field, disabled: !state.open }))}
                onChange={setOptions}
                readonly={!state.open}
                allowAddRow={state.open}
                allowRemoveRow={state.open}
            />
        </WebSettingsCard>
    )
}

export default OptionsCard
